import React, {useRef} from "react";
import Table from "../components/Tables/DeliveryTable/Table";
import AddDelivery from "../components/Tables/Actions/AddDelivery/AddDelivery";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import store from "../redux/store";
import {resetEditingRow, setIsDeliveryFormModalOpen} from "../redux/delivery/reducer";
import {SlidingContainer} from "../components/SlidingContainer/SlidingContainer";
import FormDelivery from "../components/Forms/FormDelivery/FormDelivery";

const Delivery: React.FC = () => {
    let rowData = [
        {
            id: '1',
            date: '2020-07-07T20:20:12Z',
            status: 'В работе',
            warehouse: 'ПР',
            filterWarehouse: 'Фильтр Почта России',
            count: '2',
            numberDocument: '2',
            dataDocument: '2020-07-07T20:20:12Z',
            responsible: 'Борис бритва',
            comment: 'Осторожно, стекдло',
            documents: 'акт. прием.pdf',
        },
        {
            id: '2',
            date: '2020-07-07T20:20:12Z',
            status: 'В работе',
            warehouse: 'ПР',
            filterWarehouse: 'Фильтр Почта России',
            count: '2',
            numberDocument: '2',
            dataDocument: '2020-07-07T20:20:12Z',
            responsible: 'Борис бритва',
            comment: 'Осторожно, стекдло',
            documents: 'акт. прием.pdf',
        },
        {
            id: '3',
            date: '2020-07-07T20:20:12Z',
            status: 'В работе',
            warehouse: 'ПР',
            filterWarehouse: 'Фильтр Почта России',
            count: '2',
            numberDocument: '2',
            dataDocument: '2020-07-07T20:20:12Z',
            responsible: 'Борис бритва',
            comment: 'Осторожно, стекдло',
            documents: 'акт. прием.pdf',
        },
        {
            id: '4',
            date: '2020-07-07T20:20:12Z',
            status: 'В работе',
            warehouse: 'ПР',
            filterWarehouse: 'Фильтр Почта России',
            count: '2',
            numberDocument: '2',
            dataDocument: '2020-07-07T20:20:12Z',
            responsible: 'Борис бритва',
            comment: 'Осторожно, стекдло',
            documents: 'акт. прием.pdf',
        },
    ]

    const contentRef = useRef<HTMLDivElement>(null);

    const {isDeliveryFormModalOpen} = useAppSelector(({delivery}) => ({
        isDeliveryFormModalOpen: delivery.isDeliveryFormModalOpen,
    }));

    const toOpenDeliveryFormModal = () => {
        store.dispatch(setIsDeliveryFormModalOpen(true));
    };

    const dispatch = useAppDispatch();

    const toCloseDeliveryFormModal = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsDeliveryFormModalOpen(false));
        dispatch(resetEditingRow())
    };
    const toCloseDeliveryFormModalOnClickOutside = (e: UIEvent) => {
        e.stopPropagation();
        store.dispatch(setIsDeliveryFormModalOpen(false));
        dispatch(resetEditingRow())
    };

    return (
        <div className="p-3">
            <div className="flex flex-col md:flex-row justify-between">
                <div className="mt-4 md:mt-0 w-full max-w-full overflow-hidden">

                    <nav className="flex justify-end mb-3">
                        <ul className="md:flex gap-4">
                            <li>
                                <AddDelivery toOpenDeliveryFormModal={toOpenDeliveryFormModal}  toCloseModalMenu={() => {}}></AddDelivery>
                            </li>
                        </ul>
                    </nav>

                    <div className={'flex'}>
                        <Table
                            data={rowData}
                        />
                    </div>
                </div>
            </div>
            <SlidingContainer
                title={'Добавление поставки'}
                id="delivery-form-modal"
                modalOpen={isDeliveryFormModalOpen}
                toCloseModal={toCloseDeliveryFormModal}
                toCloseModalOnClickOutside={toCloseDeliveryFormModalOnClickOutside}
                modalContent={contentRef}
            >
                <FormDelivery
                    //@ts-ignore
                    toCloseModal={toCloseDeliveryFormModal}/>
            </SlidingContainer>
        </div>
    )
}

export default Delivery;